<template>
  <div class="HeadPage">
    <div class="HeadPage-Titles">
      <div class="HeadPage-Title">{{ this.title }}</div>
      <div class="HeadPage-Title">{{ this.category }}</div>
      <div class="HBar"></div>
    </div>
    <div v-if="this.img != null || this.img != undefined" class="HeadPage-Image">
      <img :src="`/img/${this.img}`" :alt="this.imgAlt"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HeadPage',
  props: ['title', 'category', 'img', 'imgAlt']
}
</script>

<style scoped>
/* 
*   Global
*/
.HeadPage-Titles {
  background-color: rgba(0, 174, 176, 0.05);
  padding-top: 30px;
  text-align: center;
}

.HeadPage-Title:nth-child(1) {
  font-family: 'GothamBold';
  font-size: 30px;
  line-height: 30px;
  color: black;
  padding: 100px 0px 15px 0px;
}

.HeadPage-Title:nth-child(2) {
  font-family: 'GothamBook';
  font-size: 15px;
  line-height: 15px;
  color: #00AEB0;
  padding: 0px 0px 70px 0px;
}

/* 
* Image 
*/
.HeadPage-Image {
  width: 745px;
  height: 315px;
  margin: auto;
  overflow: hidden;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}

.HeadPage-Image img {
  width: 100%;
  margin-top: -60px;
}

.HeadPage-Evolution-Image .HeadPage-Image {
  display: flex;
  justify-content: center;
}

.HeadPage-Evolution-Image .HeadPage-Image img {
  width: initial !important;
  margin-top: 0px;
  vertical-align: middle;
}

.HeadPage-ConnaitreRejoindre-Image .HeadPage-Image img {
  margin-top: -180px;
}

/* 
* Bar 
*/

.HBar {
  margin: auto;
  width: 250px;
  height: 2px;
  flex: 1;
  background-color: #00AEB0;
}

/* 
* Responsive
*/
@media (max-width: 880px) {

  /*
  *   Global
  */
  .HeadPage-Title:nth-child(1) {
    font-size: 25px;
    padding: 35px 10px 10px 10px;
  }

  .HeadPage-Title:nth-child(2) {
    font-size: 12px;
    padding: 0px 10px 50px 10px;
  }

  /*
  * Image
  */
  .HeadPage-Image img {
    width: 100%;
  }

  /*
  * Bar
  */
  .HBar {
    width: 225px;
  }
}

@media (max-width: 750px) {
  /*
  * Image
  */
  .HeadPage-Image {
    width: 545px;
    height: 280px;
  }

  .HeadPage-Image img {
    margin-top: -0px !important;
  }
}

@media (max-width: 550px) {
  /*
  * Image
  */
  .HeadPage-Image {
    width: 320px;
    height: 165px;
  }

  .HeadPage-Image img {
    margin-top: 0px !important;
  }
}
</style>